import React from "react";

function Subscription() {
  return <div></div>;
}

export default Subscription;
